{
  "title": "Title",
  "note": "Note",
  "directors_note": "director's note",
  "shooting_day_number": "Shooting day number",
  "submit_shooting_day": "Submit shooting day",
  "field_required": "Field is required",
  "date": "Shooting day date",
  "add_note": "Add note",
  "update_note": "Update note",
  "create": "Create",
  "update": "Update",
  "add_shooting_day": "Add shooting day",
  "update_shooting_day": "Update shooting day",
  "due_date": "Due date"
}
